
































































































































































































































import Vue from 'vue';
import { ToggleButton } from 'vue-js-toggle-button';
import ToggleSwitch from 'vuejs-toggle-switch';

Vue.use(ToggleSwitch);
export default Vue.extend({
  name: 'FieldCheckbox',
  components: {
    ToggleButton,
  },
  props: {
    name: { type: String },
    checked: { required: false },
    label: {
      type: String,
      default: '',
    },
    labelLink: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    switchLabels: {
      type: [Array, Object],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    toggleColor: {
      type: String,
      default: 'blue',
    },
    partlyChecked: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'blue',
    },
  },
  watch: {
    checked() {
      this.isCheck = this.checked;
    },
  },
  computed: {
    getId(): string {
      if (!this.name) {
        return (
          '_' +
          Math.random()
            .toString(36)
            .substr(2, 9)
        );
      }
      return this.name
        .replace('[', '-')
        .replace(']', '')
        .toLowerCase();
    },
    issetLabel(): boolean {
      return this.label !== '';
    },
    error(): string {
      return this.errors.join(', ');
    },
  },
  methods: {
    input() {
      if (!this.partlyChecked) {
        this.isCheck = !this.isCheck;
      }
      this.$emit('input', this.isCheck ? 1 : 0);
    },
  },
  data() {
    return {
      isCheck: this.checked,
    };
  },
});
